import { Property } from "@app/models/Property";
import { Inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PropertySelectorComponent } from "@app/pages/wallet/landing/propertySelector.component";

/**
 * Created by kevin.haskett@cit.com on 11/06/20.
 */
@Injectable({ providedIn: "root" })
export class PropertySelectorService {

    constructor(@Inject(MatDialog) private dialog: MatDialog) { }

    loadProperties(properties: Property[]) {
        this.dialog.open(PropertySelectorComponent, {
            data: {
                properties: properties
            }
        })
    }
}

